module.exports = __webpack_public_path__ + "static/media/pancreascancer.c172e8ca.svg";